import * as XLSX from 'xlsx';

export class CukcukExcelReadError extends Error {
  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = 'CukcukExcelReadError';
    if (cause instanceof Error) {
      this.cause = cause;
    }
  }
}

export const normalizeSheetHint = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/\s+/g, '');

export const pickSheetName = (
  sheetNames: string[],
  hints: string[],
  fallbackIndex = 0,
): string | undefined => {
  const entries = sheetNames.map((name) => ({ name, normalized: normalizeSheetHint(name) }));
  for (const hint of hints) {
    const matched = entries.find((entry) => entry.normalized.includes(hint));
    if (matched) return matched.name;
  }
  return sheetNames[fallbackIndex];
};

export const readWorkbookFromArrayBuffer = (buffer: ArrayBuffer): XLSX.WorkBook => {
  try {
    return XLSX.read(buffer, { type: 'array', cellDates: true });
  } catch (error) {
    throw new CukcukExcelReadError(
      'File Excel không hợp lệ, bị hỏng hoặc không đọc được. Vui lòng xuất lại từ CUKCUK.',
      error,
    );
  }
};

export const readSheetMatrix = (worksheet: XLSX.WorkSheet): unknown[][] => {
  const ref = worksheet['!ref'];
  if (!ref) return [];

  const range = XLSX.utils.decode_range(ref);
  const matrix: unknown[][] = [];

  for (let row = range.s.r; row <= range.e.r; row += 1) {
    const currentRow: unknown[] = [];
    for (let col = range.s.c; col <= range.e.c; col += 1) {
      const address = XLSX.utils.encode_cell({ r: row, c: col });
      currentRow.push(worksheet[address]?.v ?? '');
    }
    matrix.push(currentRow);
  }

  return matrix;
};

export { readFileAsArrayBuffer } from './fileFingerprint';